import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getOrderRelatedTicketTypeById, isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { getGroupedLines } from '../../../utils/get-grouped-lines';
import { getKeyForOrderTicketLine } from '../../../utils/tickets/order-ticket-line-utils';
import { OrderCartContextInstance } from '../types/context';
import { OrderCartSectionDivider } from './section-divider';
import { OrderCartTicket } from './ticket';
const b = bemClassBuilder('v-order-cart-ticket-list');
export const OrderCartTicketList = observer(props => {
    const { orderTickets } = props;
    const { displayText, config, events } = useContext(OrderCartContextInstance);
    if (isEmptyArray(orderTickets))
        return null;
    const groupedTicketLines = getGroupedLines(orderTickets, getKeyForOrderTicketLine);
    return (_jsxs("ul", Object.assign({ className: b.block() }, { children: [_jsx(OrderCartSectionDivider, { title: displayText.ticketsSectionTitle, actionButtonLabel: displayText.ticketsSectionActionButtonLabel, showActionButton: config.tickets.showActionButton, onActionButtonClicked: events.onTicketsActionButtonClicked }), groupedTicketLines.map(({ key, line: ticketLine, quantity }) => {
                const ticketType = getOrderRelatedTicketTypeById(ticketLine.ticketTypeId);
                if (!ticketType)
                    throw new Error(`Could not find ticket type with ID: "${ticketLine.ticketTypeId}".`);
                return (_jsx(OrderCartTicket, { orderTicket: ticketLine, quantity: quantity, ticketType: ticketType }, key));
            })] })));
});
OrderCartTicketList.displayName = 'OrderCartTicketList';
